<template>
  <main class="main">
    <div class="anim-wrap" :class="{ loading: loading }">
      <div class="container" v-if="testData">
        <div class="row page-nav">
          <div class="col-md-8 hidden-sm">
            <nav class="breadcrumbs">
              <ol v-if="!this.personaSlug" class="breadcrumb">
                <li>
                  <a href="#" @click="$router.go(-1)" class="link-item">Hub</a>
                </li>
                <li>
                  <span class="link-item"
                    >{{ testData.firstName }} {{ testData.lastName }}</span
                  >
                </li>
              </ol>
            </nav>
          </div>
          <div class="col-md-4 text-md-right">
            <a href="#" @click="$router.go(-1)" class="link-item"
              ><font-awesome-icon icon="angle-left" /> Back</a
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <PersonalityUserCard
              :firstName="testData.firstName"
              :lastName="testData.lastName"
              :personality="testData.personality"
            />
          </div>
          <div class="col-md-7">
            <PersonalitySplitCard :personality="testData.personality" />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <PersonalityHighsAndLowsCard
              :personality="testData.personality"
              :testLanguage="testData.testLanguage"
            />
          </div>
        </div>

        <div class="row pb-before">
          <div class="col-12">
            <PersonalityCareerCard
              :personality="testData.personality"
              :psiccDescriptions="testData.psiccDescriptions"
            />
          </div>
        </div>
      </div>
      <div class="container" v-if="loadError">
        <div class="panel panel-flat text-center">
          <h1>Error</h1>
          <p>
            The profile does not exist or you do not have permission to view the
            information.
          </p>
          <button class="btn btn-link" @click="$router.go(-1)">
            Back to previous page
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// FireBase
import firebase from "firebase/app";
import "firebase/functions";

import PersonalityUserCard from "@/components/PersonalityUserCard";
import PersonalitySplitCard from "@/components/PersonalitySplitCard";
import PersonalityHighsAndLowsCard from "@/components/PersonalityHighsAndLowsCard";
import PersonalityCareerCard from "@/components/PersonalityCareerCard";

export default {
  name: "results",
  components: {
    PersonalityUserCard,
    PersonalitySplitCard,
    PersonalityHighsAndLowsCard,
    PersonalityCareerCard,
  },
  computed: {},
  data() {
    return {
      uid: null,
      source: null,
      id: null,
      personaSlug: null,
      testData: null,
      loading: false,
      testLanguage: null,
      loadError: false,
    };
  },
  mounted() {
    this.personaSlug = this.$route.query.persona;
    if (this.personaSlug) {
      const testData = {
        personality: {
          persona: this.personaSlug,
          scores: {
            ope: 50,
            con: 50,
            ext: 50,
            agr: 50,
            neu: 50,
          },
        },
      };
      this.testData = testData;
    } else {
      this.source = this.$route.query.src;
      this.uid = this.$route.query.uid;
      this.id = this.$route.query.id;
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      if (!this.id && !this.uid) {
        return false;
      }

      this.loading = true;
      let fetchData = firebase.functions().httpsCallable("getSessionData");

      fetchData({
        code: this.id,
        uid: this.uid,
        source: this.source,
      })
        .then((result) => {
          this.loading = false;
          this.loadError = false;
          this.testData = result.data;
        })
        .catch((error) => {
          this.loadError = true;
          this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>
